import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=a8fcee26&scoped=true&"
import script from "./JobDetail.vue?vue&type=script&lang=js&"
export * from "./JobDetail.vue?vue&type=script&lang=js&"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=a8fcee26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fcee26",
  null
  
)

export default component.exports